__turbopack_context__.v({
  "navBar": "_45dZgq_navBar",
  "navWrapper": "_45dZgq_navWrapper",
});
